import { Controller, useFormContext } from 'react-hook-form';

import { InputField } from '@nesso/ui/primitives/input-field';
import { MaskedInputField, US_PHONE_MASK } from '@nesso/ui/primitives/masked-input-field';

type EmailPhoneFormValues = {
    emailPrimary: string | null;
    phonePrimary: string | null;
};

type Props = {
    maxLength: number;
    // Validation only runs on blur, which would leave a server refusal and a disabled Save in place
    // while the therapist types a different email, so an error of this type revalidates on change.
    revalidateOnErrorType?: string;
};

export function EmailPhoneFields({ maxLength, revalidateOnErrorType }: Props) {
    const {
        control,
        trigger,
        formState: { isSubmitting },
    } = useFormContext<EmailPhoneFormValues>();

    return (
        <>
            <Controller
                control={control}
                name="emailPrimary"
                render={({ field, fieldState }) => (
                    <InputField
                        {...field}
                        value={field.value ?? ''}
                        onChange={(event) => {
                            field.onChange(event);
                            if (
                                revalidateOnErrorType &&
                                fieldState.error?.type === revalidateOnErrorType
                            ) {
                                void trigger('emailPrimary');
                            }
                        }}
                        id={field.name}
                        type="email"
                        label="Email"
                        disabled={isSubmitting}
                        maxLength={maxLength}
                        error={fieldState.error?.message ?? fieldState.invalid}
                    />
                )}
            />
            <Controller
                control={control}
                name="phonePrimary"
                render={({ field, fieldState }) => (
                    <MaskedInputField
                        {...field}
                        value={field.value ?? ''}
                        id={field.name}
                        label="Phone number"
                        placeholder="(   )    -    "
                        mask={US_PHONE_MASK}
                        disabled={isSubmitting}
                        error={fieldState.error?.message ?? fieldState.invalid}
                        className="max-w-37.75"
                    />
                )}
            />
        </>
    );
}
